// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__T8vzb","resendInfoText":"OnGoingPaymentBox_resendInfoText__zfo0m"};